import { callFunction } from "./client";

export interface MfaFactorRevocationResponse {
  status: "revoked" | "already_revoked";
  factor_id: string;
}

export function revokeMfaFactor(
  accessToken: string,
  factorId: string,
): Promise<MfaFactorRevocationResponse> {
  return callFunction<{ factor_id: string }, MfaFactorRevocationResponse>(
    "mfa-revoke-factor",
    { factor_id: factorId },
    { accessToken },
  );
}
